//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.Subdivision.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../Features/Features.Subdivision.SelectCageObjectData.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/Features.js";
let d=[[[0,"CrossSection",1,0],[0,"EndCaps",1,0],[1,"FalloffDistance",0,"Expression",0],[1,"GraphStructureObject",0,"Features.Subdivision.SelectCageObjectData",0],[1,"NodeSize",0,"Expression",0],[0,"NumberOfSegments",1,0],[1,"PathObject",0,"Features.Subdivision.SelectCageObjectData",0],[0,"Rod",1,0],[1,"RodSize",0,"Expression",0],[1,"Size",0,"Expression",0],[0,"Type",1,0]],[[[],"UpdateMesh",{},0,0],[["isGeometryEvaluated","origin","csys"],"GetSizeHandleGeometry",{},0,0]],[]];
SPLM.Features.Subdivision.SubdivisionTubeBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.Subdivision.SubdivisionTubeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.Subdivision.SubdivisionTubeBuilder.Types = Object.freeze({
    "SinglePath" : "SinglePath", "BranchedPath" : "BranchedPath"});

SPLM.Features.Subdivision.SubdivisionTubeBuilder.EndCapsType = Object.freeze({
    "None" : "None", "Flat" : "Flat", "Round" : "Round"});

export default SPLM;